import { HeroIdentity } from '@myap/ui-library'
/*
 * SITECODE = 'apfym'
 * APP_ID = 366
 * */
import { APP_ID } from '../../constants/AppConstants'
import HeroOversizeBackgroundCircled from '../../assets/images/AP-Pilot-Hero-Oversize-circled.png'

export const AthenaGlobalHeader = () => {
  const { origin, pathname } = window.location
  const redirectUrl = `${origin}${pathname}`
  return (
    <cbw-header
      app-id={APP_ID}
      site-title="AP"
      program-type="k-12"
      skip-target-id="main"
      use-icon-logo="true"
      use-search-widget="false"
      use-login-widget="true"
      destination-url={redirectUrl}
    />
  )
}

export const AthenaGlobalFooter = () => <cbw-footer top-target-id="main" />

export const LoginHeroWidget = () => {
  const { origin, pathname } = window.location
  return (
    <HeroIdentity
      appId={APP_ID}
      redirectUrl={`${origin}${pathname}`}
      heroContentText="Log into APRO Special Order Management Panel"
      heroBackgroundImageUrl={HeroOversizeBackgroundCircled}
      identityDesc="Sign in to your CollegeBoard account"
      professionalBtnText="Continue"
    />
  )
}
